import ROUTER_URL from "@/constant/urls";
import router from "@/router/index";
export default {
  getRoute() {
    let user_type = localStorage.getItem("user_type");
    if (user_type == "User" || user_type == null || user_type == "user") {
      return (
        ROUTER_URL.userPanel.link +
        ROUTER_URL.userPanel.children.trending.link +
        ROUTER_URL.userPanel.children.trending.children.main.link
      );
    } else if (user_type == "Admin" || user_type == "Super User") {
      return (
        ROUTER_URL.adminPanel.link + ROUTER_URL.adminPanel.children.group.link
        // ROUTER_URL.adminPanel.name
      );
    }
  },
  routeToVideoDetailPage(obj) {
    const { type, id, ptid, usid, vdid, panel } = obj;
    let query = {};
    if (type === "playlist") {
      query["ptid"] = ptid;
      query["type"] = type;
      if (vdid) {
        query["vdid"] = vdid;
      }
    } else {
      query["vdid"] = id;
      query["type"] = type;
    }
    query["usid"] = usid;
    if (panel == "admin") {
      router.push({
        name: ROUTER_URL.adminPanel.children.videoDetail.name,
        query: query,
      });
    } else {
      router.push({
        name: ROUTER_URL.userPanel.children.videoDetail.name,
        query: query,
      });
      // urlName = ROUTER_URL.userPanel.children.videoDetail.name;
    }
  },
  openSearchPage(query, return_uri) {
    router.push({
      name: ROUTER_URL.userPanel.children.searchPage.name,
      query: { q: query, return_uri: return_uri },
    });
  },
};
